import React from 'react'
import { FinanceRow, FinanceColumn } from '../Finance'

interface FinanceTableProps {
  columns: FinanceColumn[]
  rows: FinanceRow[]
  isLoading: boolean
  renderCell: (row: FinanceRow, column: FinanceColumn) => React.ReactNode
  error?: string
  emptyMessage?: string
  onRetry?: () => void
}

const FinanceTable: React.FC<FinanceTableProps> = ({
  columns,
  rows,
  isLoading,
  renderCell,
  error,
  emptyMessage = 'No records found.',
  onRetry,
}) => {
  return (
    <div className='bx-table-wrapper table-responsive'>
      <table className='bx-table text-nowrap'>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} className={column.className}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={columns.length} className='bx-finance__empty'>
                <span className='bx-finance__table-spinner' aria-hidden='true' />
                <span>Loading records...</span>
              </td>
            </tr>
          ) : error ? (
            <tr>
              <td colSpan={columns.length} className='bx-finance__empty bx-finance__empty--error'>
                <span>{error}</span>
                {onRetry ? (
                  <button type='button' className='bx-finance__retry' onClick={onRetry}>
                    Try again
                  </button>
                ) : null}
              </td>
            </tr>
          ) : rows.length ? (
            rows.map((row) => (
              <tr key={row.id}>
                {columns.map((column) => (
                  <td key={`${row.id}-${column.key}`} className={column.className}>
                    {renderCell(row, column)}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className='bx-finance__empty'>
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default FinanceTable
